mutation AddCommentReaction($cloudId: ID!, $input: ConfluenceReactionInput!) {
  confluence_addReaction(cloudId: $cloudId, input: $input) {
    ari
    containerAri
    emojiId
    __typename
  }
}
